import z from 'zod'
import { valuesValidations } from './utils'
import { validateBirthDate } from '@/utils/validations'
import { removeNonDigits } from '@/utils/string'
import { ERROR_MESSAGES } from '@/utils/defaultErrorMsg'

export const getUserConfirmDataSchema = (
  flagAddress: boolean,
  flagEmergencyContacts: boolean,
  flagPregnancy?: boolean,
  hasPregnancyData?: boolean,
) => {
  return z
    .object({
      email: z
        .string()
        .min(1, ERROR_MESSAGES.REQUIRED_FIELD)
        .email(ERROR_MESSAGES.INVALID_EMAIL),
      cellphone: z
        .string()
        .min(1, ERROR_MESSAGES.REQUIRED_FIELD)
        .trim()
        .refine(cellphone => {
          const parsedCellphone = cellphone?.replace(/[()-\s]/g, '')

          return parsedCellphone?.length === 11
        }, 'Celular inválido'),
      birthdate: z.union([
        z
          .string()
          .min(1, ERROR_MESSAGES.REQUIRED_FIELD)
          .refine(value => validateBirthDate(value), {
            message: ERROR_MESSAGES.INVALID_DATE,
          }),
        z.null(),
      ]),
      sex: z.string().min(1, ERROR_MESSAGES.REQUIRED_FIELD),
      cep: z.string(),
      streetName: z.string(),
      number: z.string(),
      neighborhood: z.string(),
      complement: z.string(),
      city: z.string(),
      state: z.string(),
      emergencyContactFullName: z.string(),
      relationship: z.string(),
      emergencyContactCellphone: z.string(),
      weeksPregnancy: z?.string(),
      daysPregnancy: z?.string(),
      lastMenstrualPeriodDate: z.any(),
    })
    .superRefine((val, ctx) => {
      valuesValidations(
        val,
        ctx,
        flagAddress,
        flagEmergencyContacts,
        flagPregnancy,
        hasPregnancyData,
      )
    })
}

export const UserConfirmDataSchema = z
  .object({
    email: z.string(),
    cellphone: z
      .string()
      .min(1, ERROR_MESSAGES.REQUIRED_FIELD)
      .trim()
      .min(15, 'Celular inválido'),
    birthdate: z.union([
      z
        .string()
        .min(1, ERROR_MESSAGES.REQUIRED_FIELD)
        .refine(value => validateBirthDate(value), {
          message: ERROR_MESSAGES.INVALID_DATE,
        }),
      z.null(),
    ]),
    sex: z.string().min(1, ERROR_MESSAGES.REQUIRED_FIELD),
    cep: z
      .string()
      .min(1, ERROR_MESSAGES.REQUIRED_FIELD)
      .min(9, 'CEP inválido'),
    streetName: z.string().min(1, ERROR_MESSAGES.REQUIRED_FIELD),
    number: z.string().min(1, ERROR_MESSAGES.REQUIRED_FIELD),
    neighborhood: z.string().min(1, ERROR_MESSAGES.REQUIRED_FIELD),
    complement: z.string(),
    city: z.string().min(1, ERROR_MESSAGES.REQUIRED_FIELD),
    state: z.string().min(1, ERROR_MESSAGES.REQUIRED_FIELD),
    emergencyContactFullName: z.string().min(1, ERROR_MESSAGES.REQUIRED_FIELD),
    relationship: z.string().min(1, ERROR_MESSAGES.REQUIRED_FIELD),
    emergencyContactCellphone: z
      .string()
      .min(1, ERROR_MESSAGES.REQUIRED_FIELD)
      .trim()
      .min(14, 'Celular inválido'),
  })
  .superRefine((val, ctx) => {
    const formattedCellPhone = removeNonDigits(val?.cellphone)
    const formattedyContactCellphone = removeNonDigits(
      val?.emergencyContactCellphone,
    )
    if (formattedCellPhone === formattedyContactCellphone) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          'Os telefones do titular e do contato de emergência devem ser diferentes.',
        path: ['emergencyContactCellphone'],
      })
    }
  })
